<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Terence Roberts was born in Ruthin, North Wales, but grew up in the old industrial heartlands of West Yorkshire. After joining West Yorkshire Probation Service as a volunteer in the mid 1980s, he later qualified as a probation officer at the University of Huddersfield and then worked for over 25 years in Merseyside, West Yorkshire and the Republic of Ireland.</p><br/>
<p style="text-indent:0em;">He moved to Ireland at the age of 50, to work in Limerick city. He is now recently retired and continues to live outside the village of O’Brien’s Bridge, County Clare, with his family of retired greyhounds, horses and donkeys.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2487d248